import React, { useState } from "react";

function CreateMergeRequestNavigationLink({ data, record, onClick }: any) {
  const handleClick = () => {
    onClick(record);
  };
  return (
    <>
      <div onClick={handleClick}>
        <div className="link"> {data}</div>
      </div>
    </>
  );
}

export default CreateMergeRequestNavigationLink;
